import { createApi } from '@reduxjs/toolkit/query/react'
import axiosBaseQuery from 'services/axiosBaseQuery'
import type { BranchListRequest, BranchListResponse } from './types'

export const branchApi = createApi({
  reducerPath: 'branchApi',
  tagTypes: ['Branches'],
  baseQuery: axiosBaseQuery({
    baseUrl: `${window.envVariables.REACT_APP_BASE_URL + '/MRF/'}`,
  }),
  endpoints: (builder) => ({
    getBranchList: builder.query<BranchListResponse, BranchListRequest>({
      query: ({ client_id, parent_branch_id }) => ({
        url: `clients/${client_id}/branch/`,
        method: 'GET',
        params: {
          parent_branch_id,
        },
      }),
      providesTags: ['Branches'],
    }),
  }),
})

export const { useGetBranchListQuery } = branchApi
